import clsx from 'clsx'
import React from 'react'

interface CellProps extends Omit<React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableCellElement>, HTMLTableCellElement>, 'className'> {
  children?: React.ReactNode;
  borderBottom?: boolean;
}

export function Cell ({ children, borderBottom = true, ...props }: CellProps) {
  return (
    <td
      {...props}
      className={clsx({ 'border-b group-last/row:border-b-0 border-gray-200': borderBottom }, 'p-4')}
    >
      {children}
    </td>
  )
}

Cell.displayName = 'PlanTable.Cell'
